var map = {
	"./bg_masked.png": "69d5",
	"./characters-bar_bg.png": "9883",
	"./de-de/img_series_101.png": "0ef8",
	"./de-de/img_series_102.png": "0396",
	"./de-de/img_series_103.png": "7ec1",
	"./de-de/img_series_104.png": "5a24",
	"./de-de/img_series_105.png": "8f4d",
	"./de-de/img_series_106.png": "a07a",
	"./de-de/img_series_107.png": "e10a",
	"./de-de/img_series_108.png": "98f4",
	"./de-de/img_series_109.png": "0344",
	"./de-de/img_series_110.png": "b81a",
	"./de-de/img_series_111.png": "77a2",
	"./de-de/img_series_112.png": "7f70",
	"./de-de/img_series_113.png": "8ebe",
	"./de-de/img_series_114.png": "6a49",
	"./de-de/img_series_115.png": "c3fa",
	"./de-de/img_series_116.png": "2dff",
	"./de-de/index_txt_a.png": "3dc2",
	"./de-de/index_txt_a_s.png": "a890",
	"./de-de/index_txt_b.png": "2e34",
	"./de-de/index_txt_b_s.png": "5a78",
	"./de-de/index_txt_c.png": "fec3",
	"./de-de/index_txt_c_s.png": "0553",
	"./de-de/index_txt_d.png": "d863",
	"./de-de/index_txt_d_s.png": "63a1",
	"./de-de/index_txt_e.png": "8a61",
	"./de-de/index_txt_e_s.png": "367a",
	"./de-de/index_txt_f.png": "d22f",
	"./de-de/index_txt_f_s.png": "4ac0",
	"./de-de/index_txt_g.png": "9837",
	"./de-de/index_txt_g_s.png": "a563",
	"./de-de/index_txt_h.png": "15ff",
	"./de-de/index_txt_h_s.png": "d372",
	"./de-de/index_txt_i.png": "fb0a",
	"./de-de/index_txt_i_s.png": "ee35",
	"./de-de/index_txt_j.png": "1044",
	"./de-de/index_txt_j_s.png": "0b14",
	"./de-de/index_txt_k.png": "c100",
	"./de-de/index_txt_k_s.png": "110a",
	"./de-de/index_txt_l.png": "ccfa",
	"./de-de/index_txt_l_s.png": "5b4f",
	"./de-de/index_txt_m.png": "6ba7",
	"./de-de/index_txt_m_s.png": "25ec",
	"./de-de/index_txt_n.png": "0f8e",
	"./de-de/index_txt_n_s.png": "b72d",
	"./de-de/index_txt_o.png": "2d78",
	"./de-de/index_txt_o_s.png": "e289",
	"./de-de/index_txt_p.png": "bb9e",
	"./de-de/index_txt_p_s.png": "3961",
	"./de-de/index_txt_q.png": "ca90",
	"./de-de/index_txt_q_s.png": "9fbd",
	"./de-de/index_txt_r.png": "2036",
	"./de-de/index_txt_r_s.png": "35fe",
	"./de-de/index_txt_s.png": "caa1",
	"./de-de/index_txt_s_s.png": "8097",
	"./de-de/index_txt_t.png": "5019",
	"./de-de/index_txt_t_s.png": "39ee",
	"./de-de/index_txt_u.png": "d934",
	"./de-de/index_txt_u_s.png": "e984",
	"./de-de/index_txt_v.png": "1bc4",
	"./de-de/index_txt_v_s.png": "8bb7",
	"./de-de/index_txt_w.png": "d036",
	"./de-de/index_txt_w_s.png": "f851",
	"./de-de/index_txt_x.png": "daa5",
	"./de-de/index_txt_x_s.png": "8f99",
	"./de-de/index_txt_y.png": "9bfb",
	"./de-de/index_txt_y_s.png": "31e2",
	"./de-de/index_txt_z.png": "8243",
	"./de-de/index_txt_z_s.png": "9653",
	"./de-de/select-btn_txt.png": "cc1f",
	"./de-de/txt_series_101.png": "8b0d",
	"./de-de/txt_series_102.png": "e458",
	"./de-de/txt_series_103.png": "7975",
	"./de-de/txt_series_104.png": "45a5",
	"./de-de/txt_series_105.png": "140c",
	"./de-de/txt_series_106.png": "a96b",
	"./de-de/txt_series_107.png": "d223",
	"./de-de/txt_series_108.png": "efb1",
	"./de-de/txt_series_109.png": "095f",
	"./de-de/txt_series_110.png": "30d0",
	"./de-de/txt_series_111.png": "42e4",
	"./de-de/txt_series_112.png": "bb71",
	"./de-de/txt_series_113.png": "b869",
	"./de-de/txt_series_114.png": "efab",
	"./de-de/txt_series_115.png": "e2d8",
	"./de-de/txt_series_116.png": "4975",
	"./en-gb/img_series_101.png": "76fb",
	"./en-gb/img_series_102.png": "01a5",
	"./en-gb/img_series_103.png": "a47d",
	"./en-gb/img_series_104.png": "ab96",
	"./en-gb/img_series_105.png": "7b03",
	"./en-gb/img_series_106.png": "7d11",
	"./en-gb/img_series_107.png": "6763",
	"./en-gb/img_series_108.png": "2696",
	"./en-gb/img_series_109.png": "5826",
	"./en-gb/img_series_110.png": "8d3a",
	"./en-gb/img_series_111.png": "0d40",
	"./en-gb/img_series_112.png": "d0cd",
	"./en-gb/img_series_113.png": "d71b",
	"./en-gb/img_series_114.png": "f226",
	"./en-gb/img_series_115.png": "427d",
	"./en-gb/img_series_116.png": "f5b9",
	"./en-gb/index_txt_a.png": "2ed2",
	"./en-gb/index_txt_a_s.png": "560c",
	"./en-gb/index_txt_b.png": "0b9a",
	"./en-gb/index_txt_b_s.png": "f7ee",
	"./en-gb/index_txt_c.png": "6e6c",
	"./en-gb/index_txt_c_s.png": "0951",
	"./en-gb/index_txt_d.png": "be2f",
	"./en-gb/index_txt_d_s.png": "7b8f",
	"./en-gb/index_txt_e.png": "688e",
	"./en-gb/index_txt_e_s.png": "0188",
	"./en-gb/index_txt_f.png": "d910",
	"./en-gb/index_txt_f_s.png": "595f",
	"./en-gb/index_txt_g.png": "a0ee",
	"./en-gb/index_txt_g_s.png": "22b2",
	"./en-gb/index_txt_h.png": "d5a4",
	"./en-gb/index_txt_h_s.png": "312c",
	"./en-gb/index_txt_i.png": "b893",
	"./en-gb/index_txt_i_s.png": "2c1b",
	"./en-gb/index_txt_j.png": "3e20",
	"./en-gb/index_txt_j_s.png": "f1d9",
	"./en-gb/index_txt_k.png": "d95f",
	"./en-gb/index_txt_k_s.png": "7131",
	"./en-gb/index_txt_l.png": "152a",
	"./en-gb/index_txt_l_s.png": "cfb9",
	"./en-gb/index_txt_m.png": "e555",
	"./en-gb/index_txt_m_s.png": "bb4e",
	"./en-gb/index_txt_n.png": "0857",
	"./en-gb/index_txt_n_s.png": "38d8",
	"./en-gb/index_txt_o.png": "e268",
	"./en-gb/index_txt_o_s.png": "ec51",
	"./en-gb/index_txt_p.png": "3b60",
	"./en-gb/index_txt_p_s.png": "0c27",
	"./en-gb/index_txt_q.png": "3f8f",
	"./en-gb/index_txt_q_s.png": "4708",
	"./en-gb/index_txt_r.png": "052b",
	"./en-gb/index_txt_r_s.png": "76bc",
	"./en-gb/index_txt_s.png": "bb41",
	"./en-gb/index_txt_s_s.png": "cf84",
	"./en-gb/index_txt_t.png": "11b2",
	"./en-gb/index_txt_t_s.png": "8de8",
	"./en-gb/index_txt_u.png": "a6c8",
	"./en-gb/index_txt_u_s.png": "108d",
	"./en-gb/index_txt_v.png": "b28c",
	"./en-gb/index_txt_v_s.png": "a821",
	"./en-gb/index_txt_w.png": "57ca",
	"./en-gb/index_txt_w_s.png": "8313",
	"./en-gb/index_txt_x.png": "caac",
	"./en-gb/index_txt_x_s.png": "042e",
	"./en-gb/index_txt_y.png": "2fa1",
	"./en-gb/index_txt_y_s.png": "998c",
	"./en-gb/index_txt_z.png": "68db",
	"./en-gb/index_txt_z_s.png": "b152",
	"./en-gb/select-btn_txt.png": "9c64",
	"./en-gb/txt_series_101.png": "131b",
	"./en-gb/txt_series_102.png": "d64f",
	"./en-gb/txt_series_103.png": "0a4a",
	"./en-gb/txt_series_104.png": "389d",
	"./en-gb/txt_series_105.png": "b1af",
	"./en-gb/txt_series_106.png": "82ee",
	"./en-gb/txt_series_107.png": "fa72",
	"./en-gb/txt_series_108.png": "32ea",
	"./en-gb/txt_series_109.png": "ff50",
	"./en-gb/txt_series_110.png": "b2dc",
	"./en-gb/txt_series_111.png": "7c4a",
	"./en-gb/txt_series_112.png": "08ce",
	"./en-gb/txt_series_113.png": "27ea1",
	"./en-gb/txt_series_114.png": "5597",
	"./en-gb/txt_series_115.png": "88d1",
	"./en-gb/txt_series_116.png": "d6b6",
	"./en-us/img_series_101.png": "83bc",
	"./en-us/img_series_102.png": "46c8",
	"./en-us/img_series_103.png": "1f93",
	"./en-us/img_series_104.png": "a5c4",
	"./en-us/img_series_105.png": "48f5",
	"./en-us/img_series_106.png": "519c",
	"./en-us/img_series_107.png": "3850",
	"./en-us/img_series_108.png": "9cca",
	"./en-us/img_series_109.png": "720a",
	"./en-us/img_series_110.png": "a88e",
	"./en-us/img_series_111.png": "75b6",
	"./en-us/img_series_112.png": "ff0c",
	"./en-us/img_series_113.png": "585b",
	"./en-us/img_series_114.png": "57ac",
	"./en-us/img_series_115.png": "524a",
	"./en-us/img_series_116.png": "7e6a",
	"./en-us/index_txt_a.png": "0bfd",
	"./en-us/index_txt_a_s.png": "f449",
	"./en-us/index_txt_b.png": "f8e6",
	"./en-us/index_txt_b_s.png": "3060",
	"./en-us/index_txt_c.png": "dbdd",
	"./en-us/index_txt_c_s.png": "a15d",
	"./en-us/index_txt_d.png": "6abf",
	"./en-us/index_txt_d_s.png": "3a0c",
	"./en-us/index_txt_e.png": "d8be",
	"./en-us/index_txt_e_s.png": "cd85",
	"./en-us/index_txt_f.png": "ea52",
	"./en-us/index_txt_f_s.png": "df7c7",
	"./en-us/index_txt_g.png": "93c7",
	"./en-us/index_txt_g_s.png": "df60",
	"./en-us/index_txt_h.png": "81b5",
	"./en-us/index_txt_h_s.png": "cc1e",
	"./en-us/index_txt_i.png": "8eaf",
	"./en-us/index_txt_i_s.png": "61b3",
	"./en-us/index_txt_j.png": "38a0",
	"./en-us/index_txt_j_s.png": "7e2e",
	"./en-us/index_txt_k.png": "5c5c",
	"./en-us/index_txt_k_s.png": "badf",
	"./en-us/index_txt_l.png": "7572",
	"./en-us/index_txt_l_s.png": "5f09",
	"./en-us/index_txt_m.png": "74f7",
	"./en-us/index_txt_m_s.png": "06be",
	"./en-us/index_txt_n.png": "5f6b",
	"./en-us/index_txt_n_s.png": "df57",
	"./en-us/index_txt_o.png": "dfe4",
	"./en-us/index_txt_o_s.png": "18af",
	"./en-us/index_txt_p.png": "4970",
	"./en-us/index_txt_p_s.png": "1be2",
	"./en-us/index_txt_q.png": "a4c20",
	"./en-us/index_txt_q_s.png": "50e5",
	"./en-us/index_txt_r.png": "203b",
	"./en-us/index_txt_r_s.png": "d8d6",
	"./en-us/index_txt_s.png": "938b",
	"./en-us/index_txt_s_s.png": "38af",
	"./en-us/index_txt_t.png": "d646",
	"./en-us/index_txt_t_s.png": "9801",
	"./en-us/index_txt_u.png": "51e4",
	"./en-us/index_txt_u_s.png": "ba93",
	"./en-us/index_txt_v.png": "5cd3",
	"./en-us/index_txt_v_s.png": "3b22",
	"./en-us/index_txt_w.png": "6341",
	"./en-us/index_txt_w_s.png": "8d0b",
	"./en-us/index_txt_x.png": "e27b",
	"./en-us/index_txt_x_s.png": "267a",
	"./en-us/index_txt_y.png": "c560",
	"./en-us/index_txt_y_s.png": "2d63",
	"./en-us/index_txt_z.png": "e2f9",
	"./en-us/index_txt_z_s.png": "3b65",
	"./en-us/select-btn_txt.png": "43e1",
	"./en-us/txt_series_101.png": "5310",
	"./en-us/txt_series_102.png": "5414",
	"./en-us/txt_series_103.png": "e806",
	"./en-us/txt_series_104.png": "6a48",
	"./en-us/txt_series_105.png": "e713",
	"./en-us/txt_series_106.png": "5ac9",
	"./en-us/txt_series_107.png": "fe8d",
	"./en-us/txt_series_108.png": "f363",
	"./en-us/txt_series_109.png": "eb75",
	"./en-us/txt_series_110.png": "4333",
	"./en-us/txt_series_111.png": "31a8",
	"./en-us/txt_series_112.png": "ecdc",
	"./en-us/txt_series_113.png": "3ac3",
	"./en-us/txt_series_114.png": "6ed9",
	"./en-us/txt_series_115.png": "3975",
	"./en-us/txt_series_116.png": "33bc",
	"./es-es/img_series_101.png": "3658",
	"./es-es/img_series_102.png": "f508",
	"./es-es/img_series_103.png": "a956",
	"./es-es/img_series_104.png": "6f5b",
	"./es-es/img_series_105.png": "83ee",
	"./es-es/img_series_106.png": "42db",
	"./es-es/img_series_107.png": "41d8",
	"./es-es/img_series_108.png": "8ad8",
	"./es-es/img_series_109.png": "e93c",
	"./es-es/img_series_110.png": "5446",
	"./es-es/img_series_111.png": "f6a3",
	"./es-es/img_series_112.png": "41da",
	"./es-es/img_series_113.png": "040d",
	"./es-es/img_series_114.png": "7cc8",
	"./es-es/img_series_115.png": "2e95",
	"./es-es/img_series_116.png": "aa72",
	"./es-es/index_txt_a.png": "9836",
	"./es-es/index_txt_a_s.png": "212a",
	"./es-es/index_txt_b.png": "7751",
	"./es-es/index_txt_b_s.png": "a479",
	"./es-es/index_txt_c.png": "8d85",
	"./es-es/index_txt_c_s.png": "c142",
	"./es-es/index_txt_d.png": "7bb3",
	"./es-es/index_txt_d_s.png": "2198",
	"./es-es/index_txt_e.png": "ce7e",
	"./es-es/index_txt_e_s.png": "0040",
	"./es-es/index_txt_f.png": "d898",
	"./es-es/index_txt_f_s.png": "b79b",
	"./es-es/index_txt_g.png": "1ce9",
	"./es-es/index_txt_g_s.png": "e5e8",
	"./es-es/index_txt_h.png": "d6f7",
	"./es-es/index_txt_h_s.png": "1d9f",
	"./es-es/index_txt_i.png": "acdc",
	"./es-es/index_txt_i_s.png": "34ed",
	"./es-es/index_txt_j.png": "a822",
	"./es-es/index_txt_j_s.png": "13a4",
	"./es-es/index_txt_k.png": "a206",
	"./es-es/index_txt_k_s.png": "d4b1",
	"./es-es/index_txt_l.png": "f77b",
	"./es-es/index_txt_l_s.png": "d317",
	"./es-es/index_txt_m.png": "04b1",
	"./es-es/index_txt_m_s.png": "9b79",
	"./es-es/index_txt_n.png": "18eb",
	"./es-es/index_txt_n_s.png": "3a65",
	"./es-es/index_txt_o.png": "6562",
	"./es-es/index_txt_o_s.png": "270e",
	"./es-es/index_txt_p.png": "1f1c",
	"./es-es/index_txt_p_s.png": "004f",
	"./es-es/index_txt_q.png": "d6c2",
	"./es-es/index_txt_q_s.png": "4c6b",
	"./es-es/index_txt_r.png": "e616",
	"./es-es/index_txt_r_s.png": "944d",
	"./es-es/index_txt_s.png": "9ce4",
	"./es-es/index_txt_s_s.png": "344d",
	"./es-es/index_txt_t.png": "2ecf",
	"./es-es/index_txt_t_s.png": "e91c",
	"./es-es/index_txt_u.png": "0fac",
	"./es-es/index_txt_u_s.png": "7062",
	"./es-es/index_txt_v.png": "4ddc",
	"./es-es/index_txt_v_s.png": "ab65",
	"./es-es/index_txt_w.png": "a238",
	"./es-es/index_txt_w_s.png": "0fb2",
	"./es-es/index_txt_x.png": "02e5",
	"./es-es/index_txt_x_s.png": "c4db",
	"./es-es/index_txt_y.png": "5e3b",
	"./es-es/index_txt_y_s.png": "ddaf",
	"./es-es/index_txt_z.png": "7f11",
	"./es-es/index_txt_z_s.png": "cad9",
	"./es-es/select-btn_txt.png": "cb86",
	"./es-es/txt_series_101.png": "4e9d",
	"./es-es/txt_series_102.png": "242a",
	"./es-es/txt_series_103.png": "2faf",
	"./es-es/txt_series_104.png": "2bdf",
	"./es-es/txt_series_105.png": "e862",
	"./es-es/txt_series_106.png": "2dca",
	"./es-es/txt_series_107.png": "51e3",
	"./es-es/txt_series_108.png": "a355",
	"./es-es/txt_series_109.png": "c1d3",
	"./es-es/txt_series_110.png": "e395",
	"./es-es/txt_series_111.png": "4003",
	"./es-es/txt_series_112.png": "ef4d",
	"./es-es/txt_series_113.png": "d8ca",
	"./es-es/txt_series_114.png": "2845",
	"./es-es/txt_series_115.png": "b303",
	"./es-es/txt_series_116.png": "a6ac",
	"./es-mx/img_series_101.png": "a679",
	"./es-mx/img_series_102.png": "2d68",
	"./es-mx/img_series_103.png": "5f26",
	"./es-mx/img_series_104.png": "5803",
	"./es-mx/img_series_105.png": "5b46",
	"./es-mx/img_series_106.png": "7af9",
	"./es-mx/img_series_107.png": "0c3e",
	"./es-mx/img_series_108.png": "729c",
	"./es-mx/img_series_109.png": "fbb2",
	"./es-mx/img_series_110.png": "c0b1",
	"./es-mx/img_series_111.png": "56b0",
	"./es-mx/img_series_112.png": "1790",
	"./es-mx/img_series_113.png": "71c5",
	"./es-mx/img_series_114.png": "1016",
	"./es-mx/img_series_115.png": "ba50",
	"./es-mx/img_series_116.png": "0496",
	"./es-mx/index_txt_a.png": "b719",
	"./es-mx/index_txt_a_s.png": "6f1f",
	"./es-mx/index_txt_b.png": "2777",
	"./es-mx/index_txt_b_s.png": "f32f",
	"./es-mx/index_txt_c.png": "17e7",
	"./es-mx/index_txt_c_s.png": "51b3",
	"./es-mx/index_txt_d.png": "1d1f",
	"./es-mx/index_txt_d_s.png": "755c",
	"./es-mx/index_txt_e.png": "ff91",
	"./es-mx/index_txt_e_s.png": "0c56",
	"./es-mx/index_txt_f.png": "a795",
	"./es-mx/index_txt_f_s.png": "4900",
	"./es-mx/index_txt_g.png": "460f",
	"./es-mx/index_txt_g_s.png": "1666",
	"./es-mx/index_txt_h.png": "e8bb",
	"./es-mx/index_txt_h_s.png": "1df3",
	"./es-mx/index_txt_i.png": "2f9d",
	"./es-mx/index_txt_i_s.png": "48d0",
	"./es-mx/index_txt_j.png": "36f8",
	"./es-mx/index_txt_j_s.png": "c3cc",
	"./es-mx/index_txt_k.png": "4ca9",
	"./es-mx/index_txt_k_s.png": "640c",
	"./es-mx/index_txt_l.png": "8c3a",
	"./es-mx/index_txt_l_s.png": "d422",
	"./es-mx/index_txt_m.png": "abe3",
	"./es-mx/index_txt_m_s.png": "131e",
	"./es-mx/index_txt_n.png": "0310",
	"./es-mx/index_txt_n_s.png": "7162",
	"./es-mx/index_txt_o.png": "ad27",
	"./es-mx/index_txt_o_s.png": "3de0",
	"./es-mx/index_txt_p.png": "4c35",
	"./es-mx/index_txt_p_s.png": "8a10",
	"./es-mx/index_txt_q.png": "8503",
	"./es-mx/index_txt_q_s.png": "c2b1",
	"./es-mx/index_txt_r.png": "13b6",
	"./es-mx/index_txt_r_s.png": "d979",
	"./es-mx/index_txt_s.png": "d703",
	"./es-mx/index_txt_s_s.png": "0e14",
	"./es-mx/index_txt_t.png": "293c5",
	"./es-mx/index_txt_t_s.png": "5676",
	"./es-mx/index_txt_u.png": "0506",
	"./es-mx/index_txt_u_s.png": "12e4",
	"./es-mx/index_txt_v.png": "b296",
	"./es-mx/index_txt_v_s.png": "47b3",
	"./es-mx/index_txt_w.png": "50f1",
	"./es-mx/index_txt_w_s.png": "19c8",
	"./es-mx/index_txt_x.png": "8425",
	"./es-mx/index_txt_x_s.png": "6df5",
	"./es-mx/index_txt_y.png": "b6b9",
	"./es-mx/index_txt_y_s.png": "3fc3",
	"./es-mx/index_txt_z.png": "823c",
	"./es-mx/index_txt_z_s.png": "dd92",
	"./es-mx/select-btn_txt.png": "4656",
	"./es-mx/txt_series_101.png": "1a69",
	"./es-mx/txt_series_102.png": "2800",
	"./es-mx/txt_series_103.png": "72d3",
	"./es-mx/txt_series_104.png": "fb2c",
	"./es-mx/txt_series_105.png": "f696",
	"./es-mx/txt_series_106.png": "a40e",
	"./es-mx/txt_series_107.png": "f088",
	"./es-mx/txt_series_108.png": "94fc",
	"./es-mx/txt_series_109.png": "f1a4",
	"./es-mx/txt_series_110.png": "5b7a",
	"./es-mx/txt_series_111.png": "e05f",
	"./es-mx/txt_series_112.png": "0bd5",
	"./es-mx/txt_series_113.png": "e921",
	"./es-mx/txt_series_114.png": "28df",
	"./es-mx/txt_series_115.png": "7747",
	"./es-mx/txt_series_116.png": "d9e3",
	"./fr-ca/img_series_101.png": "3fb6",
	"./fr-ca/img_series_102.png": "c326",
	"./fr-ca/img_series_103.png": "a164",
	"./fr-ca/img_series_104.png": "daeb",
	"./fr-ca/img_series_105.png": "aeb3",
	"./fr-ca/img_series_106.png": "bc06",
	"./fr-ca/img_series_107.png": "06cb",
	"./fr-ca/img_series_108.png": "6a70",
	"./fr-ca/img_series_109.png": "202f",
	"./fr-ca/img_series_110.png": "9f7c",
	"./fr-ca/img_series_111.png": "f236",
	"./fr-ca/img_series_112.png": "67bf",
	"./fr-ca/img_series_113.png": "35e7",
	"./fr-ca/img_series_114.png": "4be4",
	"./fr-ca/img_series_115.png": "05e0",
	"./fr-ca/img_series_116.png": "fea0",
	"./fr-ca/index_txt_a.png": "0467",
	"./fr-ca/index_txt_a_s.png": "0d94",
	"./fr-ca/index_txt_b.png": "38d2",
	"./fr-ca/index_txt_b_s.png": "19ee",
	"./fr-ca/index_txt_c.png": "9777",
	"./fr-ca/index_txt_c_s.png": "7b2f",
	"./fr-ca/index_txt_d.png": "af66",
	"./fr-ca/index_txt_d_s.png": "7803",
	"./fr-ca/index_txt_e.png": "a60f",
	"./fr-ca/index_txt_e_s.png": "4df3",
	"./fr-ca/index_txt_f.png": "3b49",
	"./fr-ca/index_txt_f_s.png": "1e44",
	"./fr-ca/index_txt_g.png": "4fd0",
	"./fr-ca/index_txt_g_s.png": "7658",
	"./fr-ca/index_txt_h.png": "cffb",
	"./fr-ca/index_txt_h_s.png": "cc1ef",
	"./fr-ca/index_txt_i.png": "fe76",
	"./fr-ca/index_txt_i_s.png": "24ee",
	"./fr-ca/index_txt_j.png": "2778",
	"./fr-ca/index_txt_j_s.png": "df8e",
	"./fr-ca/index_txt_k.png": "98cf",
	"./fr-ca/index_txt_k_s.png": "e34d",
	"./fr-ca/index_txt_l.png": "d5df",
	"./fr-ca/index_txt_l_s.png": "0912",
	"./fr-ca/index_txt_m.png": "6591",
	"./fr-ca/index_txt_m_s.png": "7927",
	"./fr-ca/index_txt_n.png": "a5c7",
	"./fr-ca/index_txt_n_s.png": "c076",
	"./fr-ca/index_txt_o.png": "58de",
	"./fr-ca/index_txt_o_s.png": "cf57",
	"./fr-ca/index_txt_p.png": "0021",
	"./fr-ca/index_txt_p_s.png": "57c5",
	"./fr-ca/index_txt_q.png": "cce8",
	"./fr-ca/index_txt_q_s.png": "2a27",
	"./fr-ca/index_txt_r.png": "4306",
	"./fr-ca/index_txt_r_s.png": "7c70",
	"./fr-ca/index_txt_s.png": "37ea",
	"./fr-ca/index_txt_s_s.png": "463b",
	"./fr-ca/index_txt_t.png": "b088",
	"./fr-ca/index_txt_t_s.png": "424d",
	"./fr-ca/index_txt_u.png": "73d2",
	"./fr-ca/index_txt_u_s.png": "2fa6",
	"./fr-ca/index_txt_v.png": "de25",
	"./fr-ca/index_txt_v_s.png": "4347",
	"./fr-ca/index_txt_w.png": "5f97",
	"./fr-ca/index_txt_w_s.png": "21ae",
	"./fr-ca/index_txt_x.png": "1faf",
	"./fr-ca/index_txt_x_s.png": "dc67",
	"./fr-ca/index_txt_y.png": "349b",
	"./fr-ca/index_txt_y_s.png": "0fc3",
	"./fr-ca/index_txt_z.png": "dde0",
	"./fr-ca/index_txt_z_s.png": "dbf6",
	"./fr-ca/select-btn_txt.png": "bc44",
	"./fr-ca/txt_series_101.png": "c6f8",
	"./fr-ca/txt_series_102.png": "be71",
	"./fr-ca/txt_series_103.png": "f6f4",
	"./fr-ca/txt_series_104.png": "4ce1",
	"./fr-ca/txt_series_105.png": "7b5d",
	"./fr-ca/txt_series_106.png": "2ebb",
	"./fr-ca/txt_series_107.png": "47c2",
	"./fr-ca/txt_series_108.png": "2973",
	"./fr-ca/txt_series_109.png": "6a1c",
	"./fr-ca/txt_series_110.png": "78da",
	"./fr-ca/txt_series_111.png": "5a2d",
	"./fr-ca/txt_series_112.png": "47e3",
	"./fr-ca/txt_series_113.png": "e9af",
	"./fr-ca/txt_series_114.png": "6c6b",
	"./fr-ca/txt_series_115.png": "3c88",
	"./fr-ca/txt_series_116.png": "6b1e",
	"./fr-fr/img_series_101.png": "84e0",
	"./fr-fr/img_series_102.png": "d611",
	"./fr-fr/img_series_103.png": "2889",
	"./fr-fr/img_series_104.png": "b8c0",
	"./fr-fr/img_series_105.png": "ebb2",
	"./fr-fr/img_series_106.png": "a5b2",
	"./fr-fr/img_series_107.png": "9d0e",
	"./fr-fr/img_series_108.png": "16da",
	"./fr-fr/img_series_109.png": "6213",
	"./fr-fr/img_series_110.png": "74b7",
	"./fr-fr/img_series_111.png": "7138",
	"./fr-fr/img_series_112.png": "3053",
	"./fr-fr/img_series_113.png": "3533",
	"./fr-fr/img_series_114.png": "8fc9",
	"./fr-fr/img_series_115.png": "8517",
	"./fr-fr/img_series_116.png": "03eb",
	"./fr-fr/index_txt_a.png": "2cb9",
	"./fr-fr/index_txt_a_s.png": "9163",
	"./fr-fr/index_txt_b.png": "f0de",
	"./fr-fr/index_txt_b_s.png": "7360",
	"./fr-fr/index_txt_c.png": "d2e5",
	"./fr-fr/index_txt_c_s.png": "e90f",
	"./fr-fr/index_txt_d.png": "833a",
	"./fr-fr/index_txt_d_s.png": "95f0",
	"./fr-fr/index_txt_e.png": "255d",
	"./fr-fr/index_txt_e_s.png": "85e4",
	"./fr-fr/index_txt_f.png": "0b25",
	"./fr-fr/index_txt_f_s.png": "158c",
	"./fr-fr/index_txt_g.png": "2252",
	"./fr-fr/index_txt_g_s.png": "d151",
	"./fr-fr/index_txt_h.png": "7014",
	"./fr-fr/index_txt_h_s.png": "c385",
	"./fr-fr/index_txt_i.png": "62ea",
	"./fr-fr/index_txt_i_s.png": "86fd",
	"./fr-fr/index_txt_j.png": "529a",
	"./fr-fr/index_txt_j_s.png": "6514",
	"./fr-fr/index_txt_k.png": "4fe4",
	"./fr-fr/index_txt_k_s.png": "c95b",
	"./fr-fr/index_txt_l.png": "b6b2",
	"./fr-fr/index_txt_l_s.png": "bacc",
	"./fr-fr/index_txt_m.png": "6bf38",
	"./fr-fr/index_txt_m_s.png": "5e67",
	"./fr-fr/index_txt_n.png": "acc1",
	"./fr-fr/index_txt_n_s.png": "22b4",
	"./fr-fr/index_txt_o.png": "fe6b",
	"./fr-fr/index_txt_o_s.png": "9309",
	"./fr-fr/index_txt_p.png": "d45f",
	"./fr-fr/index_txt_p_s.png": "e6517",
	"./fr-fr/index_txt_q.png": "645e",
	"./fr-fr/index_txt_q_s.png": "822d",
	"./fr-fr/index_txt_r.png": "91c6",
	"./fr-fr/index_txt_r_s.png": "0a9b",
	"./fr-fr/index_txt_s.png": "cbb3",
	"./fr-fr/index_txt_s_s.png": "76bb",
	"./fr-fr/index_txt_t.png": "80f3",
	"./fr-fr/index_txt_t_s.png": "293c",
	"./fr-fr/index_txt_u.png": "c000",
	"./fr-fr/index_txt_u_s.png": "bc6d",
	"./fr-fr/index_txt_v.png": "1119",
	"./fr-fr/index_txt_v_s.png": "2e20",
	"./fr-fr/index_txt_w.png": "dfc4",
	"./fr-fr/index_txt_w_s.png": "4f20",
	"./fr-fr/index_txt_x.png": "ea97",
	"./fr-fr/index_txt_x_s.png": "647c",
	"./fr-fr/index_txt_y.png": "3481",
	"./fr-fr/index_txt_y_s.png": "ec90",
	"./fr-fr/index_txt_z.png": "41ec",
	"./fr-fr/index_txt_z_s.png": "4c93",
	"./fr-fr/select-btn_txt.png": "1fa3",
	"./fr-fr/txt_series_101.png": "01ac",
	"./fr-fr/txt_series_102.png": "ba9b",
	"./fr-fr/txt_series_103.png": "da5b",
	"./fr-fr/txt_series_104.png": "0a45",
	"./fr-fr/txt_series_105.png": "fae0",
	"./fr-fr/txt_series_106.png": "b817",
	"./fr-fr/txt_series_107.png": "eff5",
	"./fr-fr/txt_series_108.png": "2e36",
	"./fr-fr/txt_series_109.png": "88b1",
	"./fr-fr/txt_series_110.png": "d171",
	"./fr-fr/txt_series_111.png": "acd8",
	"./fr-fr/txt_series_112.png": "f74f",
	"./fr-fr/txt_series_113.png": "9f86",
	"./fr-fr/txt_series_114.png": "5f34",
	"./fr-fr/txt_series_115.png": "a1a7",
	"./fr-fr/txt_series_116.png": "e403",
	"./hero_bg_bottom.png": "eb66",
	"./hero_bg_middle.png": "ecfd",
	"./hero_bg_top.png": "4bab",
	"./it-it/img_series_101.png": "fd71",
	"./it-it/img_series_102.png": "ce3b",
	"./it-it/img_series_103.png": "404d",
	"./it-it/img_series_104.png": "e67d",
	"./it-it/img_series_105.png": "1f53",
	"./it-it/img_series_106.png": "d678",
	"./it-it/img_series_107.png": "e6af",
	"./it-it/img_series_108.png": "0bf0",
	"./it-it/img_series_109.png": "42e1",
	"./it-it/img_series_110.png": "a037",
	"./it-it/img_series_111.png": "9539",
	"./it-it/img_series_112.png": "9c00",
	"./it-it/img_series_113.png": "3af2",
	"./it-it/img_series_114.png": "55e4",
	"./it-it/img_series_115.png": "e51f",
	"./it-it/img_series_116.png": "f2ca",
	"./it-it/index_txt_a.png": "5349",
	"./it-it/index_txt_a_s.png": "13de",
	"./it-it/index_txt_b.png": "9c79",
	"./it-it/index_txt_b_s.png": "61e3",
	"./it-it/index_txt_c.png": "76ee",
	"./it-it/index_txt_c_s.png": "1c5d",
	"./it-it/index_txt_d.png": "e178",
	"./it-it/index_txt_d_s.png": "2114",
	"./it-it/index_txt_e.png": "2932",
	"./it-it/index_txt_e_s.png": "696c",
	"./it-it/index_txt_f.png": "ac46",
	"./it-it/index_txt_f_s.png": "8fbb",
	"./it-it/index_txt_g.png": "6a0e",
	"./it-it/index_txt_g_s.png": "b45e",
	"./it-it/index_txt_h.png": "e00e",
	"./it-it/index_txt_h_s.png": "587d",
	"./it-it/index_txt_i.png": "ab132",
	"./it-it/index_txt_i_s.png": "22c9",
	"./it-it/index_txt_j.png": "d389",
	"./it-it/index_txt_j_s.png": "dd82",
	"./it-it/index_txt_k.png": "2442",
	"./it-it/index_txt_k_s.png": "27ea",
	"./it-it/index_txt_l.png": "4883",
	"./it-it/index_txt_l_s.png": "5f99",
	"./it-it/index_txt_m.png": "77476",
	"./it-it/index_txt_m_s.png": "0c80",
	"./it-it/index_txt_n.png": "deae",
	"./it-it/index_txt_n_s.png": "87e9",
	"./it-it/index_txt_o.png": "346a",
	"./it-it/index_txt_o_s.png": "9c72",
	"./it-it/index_txt_p.png": "d2da",
	"./it-it/index_txt_p_s.png": "b9a9",
	"./it-it/index_txt_q.png": "abc0",
	"./it-it/index_txt_q_s.png": "ea02",
	"./it-it/index_txt_r.png": "21c5",
	"./it-it/index_txt_r_s.png": "11d7",
	"./it-it/index_txt_s.png": "7ba9",
	"./it-it/index_txt_s_s.png": "9399",
	"./it-it/index_txt_t.png": "2bde",
	"./it-it/index_txt_t_s.png": "8d61",
	"./it-it/index_txt_u.png": "03f5",
	"./it-it/index_txt_u_s.png": "d508",
	"./it-it/index_txt_v.png": "1668",
	"./it-it/index_txt_v_s.png": "b9e2",
	"./it-it/index_txt_w.png": "a349",
	"./it-it/index_txt_w_s.png": "6034",
	"./it-it/index_txt_x.png": "d5e2",
	"./it-it/index_txt_x_s.png": "6e48",
	"./it-it/index_txt_y.png": "dfb0",
	"./it-it/index_txt_y_s.png": "97ff",
	"./it-it/index_txt_z.png": "d03e",
	"./it-it/index_txt_z_s.png": "c05c",
	"./it-it/select-btn_txt.png": "29bd",
	"./it-it/txt_series_101.png": "a69c",
	"./it-it/txt_series_102.png": "24bc",
	"./it-it/txt_series_103.png": "82d0",
	"./it-it/txt_series_104.png": "daaf",
	"./it-it/txt_series_105.png": "ab23",
	"./it-it/txt_series_106.png": "1a9f",
	"./it-it/txt_series_107.png": "062f",
	"./it-it/txt_series_108.png": "1e68",
	"./it-it/txt_series_109.png": "e945",
	"./it-it/txt_series_110.png": "f170",
	"./it-it/txt_series_111.png": "3bb5",
	"./it-it/txt_series_112.png": "8794",
	"./it-it/txt_series_113.png": "f650",
	"./it-it/txt_series_114.png": "b6be",
	"./it-it/txt_series_115.png": "acf7",
	"./it-it/txt_series_116.png": "a027",
	"./ja-jp/img_series_101.png": "17e8",
	"./ja-jp/img_series_102.png": "a76c",
	"./ja-jp/img_series_103.png": "7c9f",
	"./ja-jp/img_series_104.png": "4fa5",
	"./ja-jp/img_series_105.png": "c10a",
	"./ja-jp/img_series_106.png": "9252",
	"./ja-jp/img_series_107.png": "9cbe",
	"./ja-jp/img_series_108.png": "bc42",
	"./ja-jp/img_series_109.png": "21b3",
	"./ja-jp/img_series_110.png": "2047",
	"./ja-jp/img_series_111.png": "aa1d",
	"./ja-jp/img_series_112.png": "9954",
	"./ja-jp/img_series_113.png": "8003",
	"./ja-jp/img_series_114.png": "8885",
	"./ja-jp/img_series_115.png": "19bd",
	"./ja-jp/img_series_116.png": "6021",
	"./ja-jp/index_txt_a.png": "63f4",
	"./ja-jp/index_txt_a_s.png": "7a76",
	"./ja-jp/index_txt_ha.png": "bd8d",
	"./ja-jp/index_txt_ha_s.png": "7dfe",
	"./ja-jp/index_txt_ka.png": "827a",
	"./ja-jp/index_txt_ka_s.png": "7090",
	"./ja-jp/index_txt_ma.png": "7f07",
	"./ja-jp/index_txt_ma_s.png": "234a",
	"./ja-jp/index_txt_na.png": "5fcc",
	"./ja-jp/index_txt_na_s.png": "fd62",
	"./ja-jp/index_txt_ra.png": "2991",
	"./ja-jp/index_txt_ra_s.png": "78b6",
	"./ja-jp/index_txt_sa.png": "0ffc",
	"./ja-jp/index_txt_sa_s.png": "8c3f",
	"./ja-jp/index_txt_ta.png": "49753",
	"./ja-jp/index_txt_ta_s.png": "5a33",
	"./ja-jp/index_txt_wa.png": "a7bc",
	"./ja-jp/index_txt_wa_s.png": "2aef",
	"./ja-jp/index_txt_wo.png": "7624",
	"./ja-jp/index_txt_wo_s.png": "04ad",
	"./ja-jp/index_txt_ya.png": "947a",
	"./ja-jp/index_txt_ya_s.png": "8027",
	"./ja-jp/select-btn_txt.png": "5dc1",
	"./ja-jp/txt_series_101.png": "cb79",
	"./ja-jp/txt_series_102.png": "bc5b",
	"./ja-jp/txt_series_103.png": "dcb4",
	"./ja-jp/txt_series_104.png": "3d5a",
	"./ja-jp/txt_series_105.png": "f7a3",
	"./ja-jp/txt_series_106.png": "2236",
	"./ja-jp/txt_series_107.png": "58d4",
	"./ja-jp/txt_series_108.png": "e182",
	"./ja-jp/txt_series_109.png": "9e3d",
	"./ja-jp/txt_series_110.png": "c757",
	"./ja-jp/txt_series_111.png": "55e2",
	"./ja-jp/txt_series_112.png": "14eb",
	"./ja-jp/txt_series_113.png": "b710",
	"./ja-jp/txt_series_114.png": "ff52",
	"./ja-jp/txt_series_115.png": "d96d",
	"./ja-jp/txt_series_116.png": "a58d",
	"./list_bg_p1.png": "0c7c",
	"./list_bg_p2.png": "2358",
	"./nav_next.png": "7455",
	"./nav_prev.png": "5451",
	"./pt-br/img_series_101.png": "415d",
	"./pt-br/img_series_102.png": "1931",
	"./pt-br/img_series_103.png": "99d3",
	"./pt-br/img_series_104.png": "889b",
	"./pt-br/img_series_105.png": "55d9",
	"./pt-br/img_series_106.png": "5527",
	"./pt-br/img_series_107.png": "08e2",
	"./pt-br/img_series_108.png": "86f7",
	"./pt-br/img_series_109.png": "9371",
	"./pt-br/img_series_110.png": "3b88",
	"./pt-br/img_series_111.png": "afab",
	"./pt-br/img_series_112.png": "aa61",
	"./pt-br/img_series_113.png": "5233",
	"./pt-br/img_series_114.png": "e875",
	"./pt-br/img_series_115.png": "2678",
	"./pt-br/img_series_116.png": "67ea",
	"./pt-br/index_txt_a.png": "6153",
	"./pt-br/index_txt_a_s.png": "5ea7",
	"./pt-br/index_txt_b.png": "6ad7",
	"./pt-br/index_txt_b_s.png": "7749",
	"./pt-br/index_txt_c.png": "68b7",
	"./pt-br/index_txt_c_s.png": "2f48",
	"./pt-br/index_txt_d.png": "719a",
	"./pt-br/index_txt_d_s.png": "c355",
	"./pt-br/index_txt_e.png": "eb38",
	"./pt-br/index_txt_e_s.png": "3a28",
	"./pt-br/index_txt_f.png": "0c0d",
	"./pt-br/index_txt_f_s.png": "7907",
	"./pt-br/index_txt_g.png": "a67c",
	"./pt-br/index_txt_g_s.png": "eb47",
	"./pt-br/index_txt_h.png": "386e",
	"./pt-br/index_txt_h_s.png": "37f5",
	"./pt-br/index_txt_i.png": "656f",
	"./pt-br/index_txt_i_s.png": "fa4b",
	"./pt-br/index_txt_j.png": "2be8",
	"./pt-br/index_txt_j_s.png": "f280",
	"./pt-br/index_txt_k.png": "a2fe",
	"./pt-br/index_txt_k_s.png": "78bf",
	"./pt-br/index_txt_l.png": "d263",
	"./pt-br/index_txt_l_s.png": "003f",
	"./pt-br/index_txt_o.png": "d727",
	"./pt-br/index_txt_o_s.png": "35a4",
	"./pt-br/index_txt_p.png": "98bc",
	"./pt-br/index_txt_p_s.png": "2b32",
	"./pt-br/index_txt_q.png": "cda2",
	"./pt-br/index_txt_q_s.png": "23b7",
	"./pt-br/index_txt_r.png": "9ff5",
	"./pt-br/index_txt_r_s.png": "04e6",
	"./pt-br/index_txt_s.png": "2767",
	"./pt-br/index_txt_s_s.png": "015f",
	"./pt-br/index_txt_t.png": "e347",
	"./pt-br/index_txt_t_s.png": "8dae",
	"./pt-br/index_txt_u.png": "63dd",
	"./pt-br/index_txt_u_s.png": "0c0a",
	"./pt-br/index_txt_v.png": "d993",
	"./pt-br/index_txt_v_s.png": "bda4",
	"./pt-br/index_txt_w.png": "2987",
	"./pt-br/index_txt_w_s.png": "3d929",
	"./pt-br/index_txt_x.png": "e20f",
	"./pt-br/index_txt_x_s.png": "68dd",
	"./pt-br/index_txt_y.png": "d4c1",
	"./pt-br/index_txt_y_s.png": "16bd",
	"./pt-br/index_txt_z.png": "dba3",
	"./pt-br/index_txt_z_s.png": "27f6",
	"./pt-br/select-btn_txt.png": "00ec",
	"./pt-br/txt_series_101.png": "2322",
	"./pt-br/txt_series_102.png": "d79b",
	"./pt-br/txt_series_103.png": "a5b9",
	"./pt-br/txt_series_104.png": "e071",
	"./pt-br/txt_series_105.png": "7d00",
	"./pt-br/txt_series_106.png": "10fb",
	"./pt-br/txt_series_107.png": "a820",
	"./pt-br/txt_series_108.png": "749e",
	"./pt-br/txt_series_109.png": "4974",
	"./pt-br/txt_series_110.png": "cb03",
	"./pt-br/txt_series_111.png": "fe4c",
	"./pt-br/txt_series_112.png": "6147",
	"./pt-br/txt_series_113.png": "b08c",
	"./pt-br/txt_series_114.png": "25cb",
	"./pt-br/txt_series_115.png": "11f4",
	"./pt-br/txt_series_116.png": "2c96",
	"./zh-tw/img_series_101.png": "d09c",
	"./zh-tw/img_series_102.png": "f3b2",
	"./zh-tw/img_series_103.png": "8f45",
	"./zh-tw/img_series_104.png": "2482",
	"./zh-tw/img_series_105.png": "4ead",
	"./zh-tw/img_series_106.png": "97d1",
	"./zh-tw/img_series_107.png": "e00a",
	"./zh-tw/img_series_108.png": "f474",
	"./zh-tw/img_series_109.png": "80032",
	"./zh-tw/img_series_110.png": "935d",
	"./zh-tw/img_series_111.png": "f69b",
	"./zh-tw/img_series_112.png": "6a01",
	"./zh-tw/img_series_113.png": "beb3",
	"./zh-tw/img_series_114.png": "a574",
	"./zh-tw/img_series_115.png": "fd02",
	"./zh-tw/img_series_116.png": "217f",
	"./zh-tw/index_txt_a.png": "8194",
	"./zh-tw/index_txt_a_s.png": "a5069",
	"./zh-tw/index_txt_b.png": "e23b",
	"./zh-tw/index_txt_b_s.png": "a51f",
	"./zh-tw/index_txt_c.png": "4835",
	"./zh-tw/index_txt_c_s.png": "3ea0",
	"./zh-tw/index_txt_d.png": "b61f",
	"./zh-tw/index_txt_d_s.png": "5793",
	"./zh-tw/index_txt_e.png": "9ae6",
	"./zh-tw/index_txt_e_s.png": "2499",
	"./zh-tw/index_txt_f.png": "578b",
	"./zh-tw/index_txt_f_s.png": "1d29",
	"./zh-tw/index_txt_g.png": "d172",
	"./zh-tw/index_txt_g_s.png": "e771",
	"./zh-tw/index_txt_h.png": "986b",
	"./zh-tw/index_txt_h_s.png": "c6d3",
	"./zh-tw/index_txt_i.png": "cdbe",
	"./zh-tw/index_txt_i_s.png": "e520",
	"./zh-tw/index_txt_j.png": "1822",
	"./zh-tw/index_txt_j_s.png": "f01a",
	"./zh-tw/index_txt_k.png": "cb61",
	"./zh-tw/index_txt_k_s.png": "27fd",
	"./zh-tw/index_txt_l.png": "b6a0",
	"./zh-tw/index_txt_l_s.png": "ca73",
	"./zh-tw/index_txt_o.png": "1758",
	"./zh-tw/index_txt_o_s.png": "95cb",
	"./zh-tw/index_txt_p.png": "898b",
	"./zh-tw/index_txt_p_s.png": "5a0a",
	"./zh-tw/index_txt_q.png": "67cb",
	"./zh-tw/index_txt_q_s.png": "efcf",
	"./zh-tw/index_txt_r.png": "97ba",
	"./zh-tw/index_txt_r_s.png": "9ab1",
	"./zh-tw/index_txt_s.png": "a9c7",
	"./zh-tw/index_txt_s_s.png": "b243",
	"./zh-tw/index_txt_t.png": "84ca",
	"./zh-tw/index_txt_t_s.png": "6e69",
	"./zh-tw/index_txt_u.png": "96fb",
	"./zh-tw/index_txt_u_s.png": "a217",
	"./zh-tw/index_txt_v.png": "39fd",
	"./zh-tw/index_txt_v_s.png": "7645",
	"./zh-tw/index_txt_w.png": "8307",
	"./zh-tw/index_txt_w_s.png": "d320",
	"./zh-tw/index_txt_x.png": "cd37",
	"./zh-tw/index_txt_x_s.png": "5716",
	"./zh-tw/index_txt_y.png": "0629",
	"./zh-tw/index_txt_y_s.png": "3472",
	"./zh-tw/index_txt_z.png": "f3f1",
	"./zh-tw/index_txt_z_s.png": "2f82",
	"./zh-tw/select-btn_txt.png": "f6da",
	"./zh-tw/txt_series_101.png": "037a",
	"./zh-tw/txt_series_102.png": "47bd",
	"./zh-tw/txt_series_103.png": "30a5",
	"./zh-tw/txt_series_104.png": "9203",
	"./zh-tw/txt_series_105.png": "8b1f",
	"./zh-tw/txt_series_106.png": "7e0e",
	"./zh-tw/txt_series_107.png": "841d",
	"./zh-tw/txt_series_108.png": "636c",
	"./zh-tw/txt_series_109.png": "f8cb",
	"./zh-tw/txt_series_110.png": "8cd4",
	"./zh-tw/txt_series_111.png": "b1d4",
	"./zh-tw/txt_series_112.png": "9b5d",
	"./zh-tw/txt_series_113.png": "5929",
	"./zh-tw/txt_series_114.png": "0a1d",
	"./zh-tw/txt_series_115.png": "a04b",
	"./zh-tw/txt_series_116.png": "5539"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b71";